import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function AudienceSection() {
  return <section className="w-full bg-[#1a2342] py-20 md:py-28" data-id="element-1">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-3">
          <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl font-bold text-[#f0ebe3]" data-id="element-4">
            ¿Es Para Ti?
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-5">
          {/* Who This Is For */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="bg-[#0f1629]/60 p-8 rounded-2xl border border-[#c9a96e]/30" data-id="element-6">
            <h3 className="font-['Playfair_Display'] text-2xl font-bold text-[#c9a96e] mb-6" data-id="element-7">
              Esto ES Para Ti Si...
            </h3>
            <ul className="space-y-4" data-id="element-8">
              <li className="flex gap-3 items-start" data-id="element-9">
                <CheckCircleIcon className="w-6 h-6 text-[#c9a96e] flex-shrink-0 mt-0.5" data-id="element-10" />
                <span className="text-[#f0ebe3]/90 leading-relaxed" data-id="element-11">
                  Sientes que has perdido tu orgullo por culpa de una ruptura o
                  un casi-algo.
                </span>
              </li>
              <li className="flex gap-3 items-start" data-id="element-12">
                <CheckCircleIcon className="w-6 h-6 text-[#c9a96e] flex-shrink-0 mt-0.5" data-id="element-13" />
                <span className="text-[#f0ebe3]/90 leading-relaxed" data-id="element-14">
                  No puedes dormir esperando un mensaje que no llega.
                </span>
              </li>
              <li className="flex gap-3 items-start" data-id="element-15">
                <CheckCircleIcon className="w-6 h-6 text-[#c9a96e] flex-shrink-0 mt-0.5" data-id="element-16" />
                <span className="text-[#f0ebe3]/90 leading-relaxed" data-id="element-17">
                  Te sientes "loca" u "obsesiva" y quieres volver a ser la mujer
                  segura que eras antes.
                </span>
              </li>
              <li className="flex gap-3 items-start" data-id="element-18">
                <CheckCircleIcon className="w-6 h-6 text-[#c9a96e] flex-shrink-0 mt-0.5" data-id="element-19" />
                <span className="text-[#f0ebe3]/90 leading-relaxed" data-id="element-20">
                  Vives en los Estados Unidos y sientes el aislamiento de una
                  ruptura lejos de tu círculo de apoyo principal.
                </span>
              </li>
            </ul>
          </motion.div>

          {/* Who This Is NOT For */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-[#0f1629]/60 p-8 rounded-2xl border border-[#a0998e]/30" data-id="element-21">
            <h3 className="font-['Playfair_Display'] text-2xl font-bold text-[#a0998e] mb-6" data-id="element-22">
              Esto NO Es Para Ti Si...
            </h3>
            <ul className="space-y-4" data-id="element-23">
              <li className="flex gap-3 items-start" data-id="element-24">
                <XCircleIcon className="w-6 h-6 text-[#a0998e] flex-shrink-0 mt-0.5" data-id="element-25" />
                <span className="text-[#f0ebe3]/70 leading-relaxed" data-id="element-26">
                  Buscas trucos psicológicos para "recuperar a tu ex".
                </span>
              </li>
              <li className="flex gap-3 items-start" data-id="element-27">
                <XCircleIcon className="w-6 h-6 text-[#a0998e] flex-shrink-0 mt-0.5" data-id="element-28" />
                <span className="text-[#f0ebe3]/70 leading-relaxed" data-id="element-29">
                  No estás dispuesta a bloquear o silenciar el contacto por al
                  menos 3 días.
                </span>
              </li>
              <li className="flex gap-3 items-start" data-id="element-30">
                <XCircleIcon className="w-6 h-6 text-[#a0998e] flex-shrink-0 mt-0.5" data-id="element-31" />
                <span className="text-[#f0ebe3]/70 leading-relaxed" data-id="element-32">
                  Prefieres quedarte en el papel de víctima en lugar de tomar
                  acción inmediata.
                </span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}